import { TAG_TYPES, TOGGLE_SWITCH_STATUS } from "constants/constants";
import styled from "styled-components";
import colors from "assets/styles/mixins/colors.scss";
import ToggleSwitchButton from "core/buttons/toggle-switch-button/ToggleSwitchButton";
import Icon from "core/icon/Icon";
import { getFormattedDate } from "./functions";
import { Link } from "react-router-dom";
import { FormattedMessage } from "react-intl";

export const getSwitchButtonValue = (val) => {
  switch (val) {
    case "green":
      return TOGGLE_SWITCH_STATUS.ON;
    case "red":
      return TOGGLE_SWITCH_STATUS.OFF;
    case "orange":
      return TOGGLE_SWITCH_STATUS.NA;
    default:
  }
};

export const headerClient = (props) => {
  const {
    key,
    value,
    icon,
    prospValues,
    type,
    manager_id,
    id,
    isUserAuthorized,
  } = props;

  const isManager = manager_id === id;
  const releaseKey = type ? "release_client" : prospValues?.releasePropsKey;
  const clientRelease = (
    <FormattedMessage id="release" defaultMessage="Libérer" />
  );
  const prospectionRelease = (
    <FormattedMessage
      id="release_prospection"
      defaultMessage="Libérer la prospection"
    />
  );
  const releaseValue = type ? clientRelease : prospectionRelease;
  const addLabel = isUserAuthorized
    ? { key: prospValues?.addKey, value: prospValues?.addValue }
    : undefined;

  return [
    {
      label: {
        key: "client",
        value: <FormattedMessage id="client" defaultMessage="Client" />,
      },
      icon: "user",
      width: "30%",
    },
    {
      label: {
        key: "from",
        value: <FormattedMessage id="from" defaultMessage="Depuis le " />,
      },
      icon: "calendar",
      width: "10%",
    },
    {
      label: { key, value },
      icon,
      width: "14%",
    },
    {
      label: {
        key: "light",
        value: <FormattedMessage id="light" defaultMessage="Feu" />,
      },
      icon: "traffic-light",
      width: type ? "14%" : "5%",
      borderRight: !isManager && "none",
    },
    {
      label: {
        key: releaseKey,
        value: releaseValue,
      },
      icon: "minus",
      width: isManager ? "16%" : "auto",
      display: !isManager && "none",
      borderRight: isManager && "none",
    },
    {
      label: addLabel,
      icon: prospValues?.addIconKey,
      width: isUserAuthorized ? "12%" : "auto",
      borderRight: !isUserAuthorized && "none",
      display: !isUserAuthorized && type && "none",
    },
    {
      label: { key: "", value: "" },
      icon: "",
      width: !isUserAuthorized ? "10%" : "12%",
      display: !isUserAuthorized && type ? "none" : "",
    },
  ];
};

export const headerProspection = (props) => {
  const { prospValues, manager_id, isUserAuthorized, id, type } = props;

  const isManager = manager_id === id;
  const releaseKey = type ? "release_client" : prospValues?.releasePropsKey;
  const clientRelease = (
    <FormattedMessage id="release" defaultMessage="Libérer" />
  );
  const prospectionRelease = (
    <FormattedMessage
      id="release_prospection"
      defaultMessage="Libérer la prospection"
    />
  );
  const releaseValue = type ? clientRelease : prospectionRelease;
  const addLabel = isUserAuthorized
    ? { key: prospValues?.addKey, value: prospValues?.addValue }
    : undefined;

  return [
    {
      label: { key: "client", value: "Client" },
      icon: "user",
      width: "38%",
    },
    {
      label: {
        key: "from",
        value: <FormattedMessage id="from" defaultMessage="Depuis le " />,
      },
      icon: "calendar",
      width: "15%",
    },
    {
      label: {
        key: "light",
        value: <FormattedMessage id="light" defaultMessage="Feu" />,
      },
      icon: "traffic-light",
      width: "10%",
    },
    {
      label: {
        key: releaseKey,
        value: releaseValue,
      },
      icon: "minus",
      width: isManager ? "16%" : "0",
      display: !isManager && "none",
    },
    {
      label: addLabel,
      icon: prospValues?.addIconKey,
      width: isUserAuthorized ? "auto" : "none",
      borderRight: !isManager && "none",
      display: !isUserAuthorized && "none",
    },
    {
      label: { key: "", value: "" },
      icon: "",
      width: "12%",
      display: isUserAuthorized ? "none" : "",
    },
  ];
};

export const displayProspections = ({
  setClientCreationData,
  lang,
  prospectionList,
  setOpenReleaseModal,
  userScope,
  isUserAuthorized,
  manager_id,
  id,
  setClientName,
  setClientId,
  setReleaseFunction,
  releaseProspection,
  setProspectionData,
  setOpenProspectionModal,
}) => {
  const handleReleaseClientClick = (elm) => {
    setClientId(elm.id);
    setClientName(elm.name);
    setReleaseFunction(() => () => releaseProspection(elm.id));
    setOpenReleaseModal(true);
  };

  return prospectionList?.map((elm) => {
    const displayModifyColumn =
      manager_id === id
        ? {
            modify_client: (
              <>
                <ModifyButton
                  onClick={() => {
                    setProspectionData(elm);
                    setOpenProspectionModal(true);
                  }}
                  type="button"
                  id="button-form-next"
                >
                  <Icon
                    icon="lightupdate"
                    color="light-slate-gray"
                    marginRight="7"
                  />
                  <FormattedMessage id="edit" defaultMessage="Modifier" />
                </ModifyButton>
              </>
            ),
          }
        : {};

    const displayReleaseColumn =
      manager_id === id
        ? {
            release_client: (
              <ReleaseButton
                onClick={() => handleReleaseClientClick(elm)}
                type="button"
                id="button-form-next"
              >
                <FormattedMessage id="release" defaultMessage="Libérer" />
              </ReleaseButton>
            ),
          }
        : {};

    const displayCreateColumn = isUserAuthorized
      ? {
          add_client: (
            <>
              <ReleaseButton
                id="button-form-next"
                onClick={() => {
                  setClientCreationData({
                    sector_id: elm.sector_id,
                    client_name: elm.name,
                  });
                  window.location.href = `/${userScope}/client/creation`;
                }}
              >
                <FormattedMessage id="create" defaultMessage="Créer" />
              </ReleaseButton>
            </>
          ),
        }
      : {};

    return {
      id: elm.id,
      client: <p key={elm.id}>{elm?.name}</p>,
      from: getFormattedDate(elm?.attribution_date, lang),
      status: (
        <ToggleSwitchButton
          index={`prospections-${elm.id}`}
          value={getSwitchButtonValue(elm?.color_light)}
          disabled={true}
        />
      ),
      ...displayReleaseColumn,
      ...displayCreateColumn,
      ...displayModifyColumn,
    };
  });
};

export const formatUserClient = ({
  userClientList,
  lang,
  userScope,
  setTrafficLightValue,
  setClientId,
  setOpenTrafficModal,
  setOpenReleaseModal,
  setClientName,
  manager_id,
  id,
  releaseClient,
  setReleaseFunction,
}) => {
  const handleReleaseClientClick = (elm) => {
    setClientName(elm.name);
    setClientId(elm.id);
    setReleaseFunction(
      () => () =>
        releaseClient({
          client_id: elm?.id,
          manager_id: manager_id,
        })
    );
    setOpenReleaseModal(true);
  };

  const displayColumn = (elm) =>
    manager_id === id
      ? {
          release_client: elm?.current_missions === 0 && (
            <ReleaseButton
              onClick={() => handleReleaseClientClick(elm)}
              type="button"
              id="button-form-next"
            >
              <FormattedMessage id="release" defaultMessage="Libérer" />
            </ReleaseButton>
          ),
        }
      : {};

  return userClientList?.map((elm) => ({
    id: elm.id,
    client: <Link to={`/${userScope}/client/${elm?.slug}`}>{elm?.name}</Link>,
    from: getFormattedDate(elm?.since, lang),
    missions_count: elm?.current_missions,
    status: (
      <div className="modify-btn">
        <ToggleSwitchButton
          index={`clients${elm.id}`}
          value={getSwitchButtonValue(elm.traffic_light)}
          disabled={true}
        />
        {manager_id === id && (
          <ModifyButton
            onClick={() => {
              setTrafficLightValue(elm.traffic_light);
              setClientId(elm.id);
              setOpenTrafficModal(true);
            }}
            type="button"
            id="button-form-next"
          >
            <Icon icon="lightupdate" color="light-slate-gray" marginRight="7" />
            <FormattedMessage id="modify" defaultMessage="Modifier" />
          </ModifyButton>
        )}
      </div>
    ),
    ...displayColumn(elm),
  }));
};

export const ModifyButton = styled.button`
  background-color: transparent;
  border: none;
  text-decoration: underline;
  color: #8280a4;
  margin-left: 0.75rem;
`;

export const ReleaseButton = styled.button`
  background-color: transparent;
  border: 1px solid ${colors["light-slate-gray"]};
  color: #8280a4;
  border-radius: 25px;
  margin-bottom: 0.75rem;
  box-shadow: 0 0 5px ${colors["light-slate-gray"]};
  width: 97px;
  height: 34px;
  font-size: 14px;
  &:hover {
    background-color: ${colors["violet"]};
    color: white;
  }
  transition: background-color 0.2s ease-in-out;
`;

export const formatSentData = (data) => ({
  ...data,
  affiliate_id: data.affiliate_id[0]?.value,
  assigned_managers: data?.assigned_managers?.map((elm) => elm?.value),
});

export const getAffiliateName = ({ list, id }) => {
  return list
    .filter((elm) => elm.id === id)
    .map((elm) => ({
      value: elm.id,
      label: elm.full_name || `${elm.first_name} ${elm.last_name}`,
    }));
};

const hasValidName = (item) => {
  const isValid = (v) => v != null && v !== "" && v !== "null";
  return isValid(item?.first_name) && isValid(item?.last_name);
};

export const getAssignedManagers = ({ list, ids }) => {
  return list
    .filter((item) => ids?.includes(item.id) && hasValidName(item))
    .map((item) => ({
      value: item.id,
      label: item.full_name || `${item.first_name} ${item.last_name}`,
      type: TAG_TYPES.PEOPLE,
    }));
};

export const formatResult = (data) =>
  data?.map((elm) => ({
    first_name: elm?.first_name,
    last_name: elm?.last_name,
    id: elm?.id,
    type: TAG_TYPES.PEOPLE,
  }));

export const formatBillingHistoryToCreate = (data) => ({
  client_id: data?.client_id,
  billing_client_id: data?.billing_client_id,
  establishment_date: data?.establishment_date,
});
